

















































import { Vue, Component } from "vue-property-decorator";
import { appModule } from "@/store/modules/app";
import 'vue-datetime/dist/vue-datetime.css';
// import '@/assets/scss/linemsg.scss';

@Component
export default class LineMessageConsole extends Vue {
    public dataitem = {
        measure_at: new Date().toISOString()
    }
    public column = "radio-1";
    public sheet = false;
    send() {
        console.log(this.dataitem);
    }

    sendView() {
        this.sheet = true;
    }
}



